import { useCallback, useContext, useState } from "react";
import { AuthContext, AuthContextValue } from "./AuthProvider";
import { ApiError, toApiError } from "../network/mainClient/apiError";
import { TFactor } from "../models/Factors";

type StartLoginResult = {
  authSessionId: string;
  process:
    | "AUTH_PROCESS_UNSPECIFIED"
    | "AUTH_PROCESS_SIGN_IN"
    | "AUTH_PROCESS_SIGN_UP";
  factor: TFactor;
};

export const useStartLogin = (): [
  StartLoginResult | null,
  boolean,
  ApiError | null,
  (
    flow: "LOGIN_FLOW_COCKPIT" | "LOGIN_FLOW_USER_APP",
    identity: string,
    verificationRequestId?: number,
    verificationRequestToken?: string
  ) => void
] => {
  const { startLogin } = useContext<AuthContextValue>(AuthContext);
  const [result, setResult] = useState<StartLoginResult | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | null>(null);

  const request = useCallback(
    async (
      flow: "LOGIN_FLOW_COCKPIT" | "LOGIN_FLOW_USER_APP",
      identity: string,
      verificationRequestId?: number,
      verificationRequestToken?: string
    ) => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await startLogin(
          flow,
          identity,
          verificationRequestId,
          verificationRequestToken
        );
        setResult(response);
      } catch (e) {
        setError(toApiError(e));
        throw e;
      } finally {
        setIsLoading(false);
      }
    },
    [startLogin]
  );

  return [result, isLoading, error, request];
};
